module.exports = __webpack_public_path__ + "img/about-18.a97d8c31.png";